import React from "react";
import InputGenerico from "../inputGenerico/inputGenerico";
import SelectGenerico from "../selectGenerico/selectGenerico";

interface FormValues {
  cdCidade: string;
  nmUsuario: string;
  nmEmail: string;
  nmSexo: string;
  nmLogradouro: string;
  nmBairro: string;
  nmComplemento: string;
  dsLogin: string;
  dsSenha: string;
  confirmacaoSenha: string;
  dsCpf: string;
  dsContato: string;
  dsContatoOpcional: string;
  dsCep: string;
  dtNascimento: string;
  nrLogradouro: string;
  dmResidencial: boolean;
  perfil: string;
  cidade: string;
}
interface Props {
  formValues: FormValues;
  validacaoAtiva: boolean;
  disabled?: boolean;
  handleFieldChange?: (name: string, value: string | number | boolean) => void;
  handleMaskChange?: (name: string, value: string) => void;
  handleFieldBlur?: (name: string, value: string) => void;
  mostrarSenha?: boolean;
}

const sexos = [
  { valor: "M", rotulo: "Masculino" },
  { valor: "F", rotulo: "Feminino" },
  { valor: "O", rotulo: "Outro" },
];

const CamposFormulario: React.FC<Props> = ({
  formValues = {} as FormValues,
  validacaoAtiva,
  disabled = false,
  handleFieldChange,
  handleMaskChange,
  handleFieldBlur,
  mostrarSenha = true
}) => {
  const handleDateChange = (name: string, value: string) => {
    if (name === "dtNascimento") {
      const parts = value.split("-");
      const year = parseInt(parts[0]);
      const currentYear = new Date().getFullYear();
      if (year > currentYear - 16) {
        const correctedDate = `2007-${parts[1]}-${parts[2]}`;
        return handleFieldChange ? handleFieldChange(name, correctedDate) : undefined;
      }
    }
    return handleFieldChange ? handleFieldChange(name, value) : undefined;
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-6">
          <InputGenerico
            name="nmUsuario"
            disabled={disabled}
            value={formValues.nmUsuario || ""}
            onChange={(event) =>
              handleFieldChange ? handleFieldChange(event.target.name, event.target.value) : undefined
            }
            label="Nome*:"
            placeholder={formValues.nmUsuario ? formValues.nmUsuario : "Digite seu nome..."}
            className={`form-control mb-4 ${
              !formValues.nmUsuario?.length && validacaoAtiva ? "input-invalid" : ""
            }`}
            validacaoAtiva={validacaoAtiva}
            type="text"
            maxLength={100}
          />
          <InputGenerico
            name="dsLogin"
            disabled={disabled}
            value={formValues.dsLogin || ""}
            onChange={(event) =>
              handleFieldChange ? handleFieldChange(event.target.name, event.target.value) : undefined
            }
            label="Apelido*:"
            placeholder="Digite seu apelido..."
            className={`form-control mb-4 ${
              !formValues.dsLogin?.length && validacaoAtiva ? "input-invalid" : ""
            }`}
            validacaoAtiva={validacaoAtiva}
            type="text"
            maxLength={100}
          />
          <InputGenerico
            name="nmEmail"
            disabled={disabled}
            value={formValues.nmEmail || ""}
            onChange={(event) =>
              handleFieldChange ? handleFieldChange(event.target.name, event.target.value) : undefined
            }
            label="E-mail*:"
            placeholder="Digite seu e-mail..."
            className={`form-control mb-4 ${
              !formValues.nmEmail?.length && validacaoAtiva ? "input-invalid" : ""
            }`}
            validacaoAtiva={validacaoAtiva}
            type="email"
            maxLength={100}
          />
          {mostrarSenha && (
            <>
              <InputGenerico
                name="dsSenha"
                disabled={disabled}
                value={formValues.dsSenha || ""}
                onChange={(event) =>
                  handleFieldChange ? handleFieldChange(event.target.name, event.target.value) : undefined
                }
                label="Senha*:"
                placeholder="Digite sua senha..."
                className={`form-control mb-4 ${
                  !formValues.dsSenha?.length && validacaoAtiva ? "input-invalid" : ""
                }`}
                validacaoAtiva={validacaoAtiva}
                type="password"
                maxLength={12}
              />
              <InputGenerico
                name="confirmacaoSenha"
                disabled={disabled}
                value={formValues.confirmacaoSenha || ""}
                onChange={(event) =>
                  handleFieldChange ? handleFieldChange(event.target.name, event.target.value) : undefined
                }
                label="Confirmar senha*:"
                placeholder="Confirme sua senha..."
                className={`form-control mb-4 ${
                  !formValues.confirmacaoSenha?.length && validacaoAtiva ? "input-invalid" : ""
                }`}
                validacaoAtiva={validacaoAtiva}
                type="password"
                maxLength={12}
              />
            </>
          )}
        </div>
        <div className="col-12 col-md-6">
          <InputGenerico
            name="dsCpf"
            disabled={disabled}
            value={formValues.dsCpf || ""}
            onChange={(event) =>
              handleMaskChange ? handleMaskChange(event.target.name, event.target.value) : undefined
            }
            onBlur={(event) =>
              handleFieldBlur ? handleFieldBlur(event.target.name, event.target.value) : undefined
            }
            label="CPF*:"
            placeholder="Digite seu CPF..."
            className={`form-control mb-4 ${
              !formValues.dsCpf?.length && validacaoAtiva ? "input-invalid" : ""
            }`}
            validacaoAtiva={validacaoAtiva}
            type="text"
            maxLength={14}
          />
          <InputGenerico
            name="dtNascimento"
            disabled={disabled}
            value={formValues.dtNascimento || ""}
            onChange={(event) =>
              handleDateChange(event.target.name, event.target.value as string)
            }
            label="Data de nascimento*:"
            placeholder="Digite sua data de nascimento..."
            className={`form-control mb-4 ${
              !formValues.dtNascimento?.length && validacaoAtiva ? "input-invalid" : ""
            }`}
            validacaoAtiva={validacaoAtiva}
            type="date"
            min="1900-01-01"
            max={new Date().toISOString().split("T")[0]}
          />
          <SelectGenerico
            disabled={disabled}
            opcoes={sexos.map((sexo) => ({
              valor: sexo.valor,
              rotulo: `${sexo.rotulo}`,
            }))}
            valorSelecionado={formValues.nmSexo}
            onChange={(value) =>
              handleFieldChange ? handleFieldChange("nmSexo", value) : undefined
            }
            label="Sexo*:"
            mensagemError="erro"
            opcaoPadrao="Selecione o sexo..."
            classe={`selectUf form-select mb-4 ${
              !formValues.nmSexo && validacaoAtiva ? "select-invalid" : ""
            }`}
            classPadrao="corOption"
            validacaoAtiva={validacaoAtiva}
          />
          {mostrarSenha && (
            <div>
              <InputGenerico
                name="dsContato"
                disabled={disabled}
                value={formValues.dsContato || ""}
                onChange={(event) =>
                  handleMaskChange ? handleMaskChange(event.target.name, event.target.value) : undefined
                }
                onBlur={(event) =>
                  handleFieldBlur ? handleFieldBlur(event.target.name, event.target.value) : undefined
                }
                label="Telefone*:"
                placeholder="Digite seu número de telefone..."
                className={`form-control mb-4 ${
                  !formValues.dsContato?.length && validacaoAtiva ? "input-invalid" : ""
                }`}
                validacaoAtiva={validacaoAtiva}
                type="text"
                maxLength={15}
              />
              <InputGenerico
                name="dsContatoOpcional"
                disabled={disabled}
                value={formValues.dsContatoOpcional || ""}
                onChange={(event) =>
                  handleMaskChange ? handleMaskChange(event.target.name, event.target.value) : undefined
                }
                onBlur={(event) =>
                  handleFieldBlur ? handleFieldBlur(event.target.name, event.target.value) : undefined
                }
                label="Telefone opcional:"
                placeholder="Digite um número de telefone opcional..."
                className="form-control mb-4"
                validacaoAtiva={validacaoAtiva}
                type="text"
                maxLength={15}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );  
};

export default CamposFormulario;
